// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .selected[data-v-23066dd5] {\n  background: #eddaf3;\n}\n.box-config[data-v-23066dd5] {\n  max-height: 300px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.chip-custom[data-v-23066dd5] {\n  font-size: 12px;\n  color: #ffb300;\n}\n[dir] .chip-custom[data-v-23066dd5] {\n  margin-top: 10px;\n  background: #fff5df;\n  border-radius: 10px;\n  padding: 4px 8px;\n}\n", ""]);
// Exports
module.exports = exports;
